import { Text } from '@react-pdf/renderer';
import { styles } from '../PDFStyle';
import { useTranslation } from 'react-i18next';

interface IPDFFooterProps {}

const PDFFooter = (props: IPDFFooterProps) => {
    const { t, i18n } = useTranslation();
    return (
        <Text style={styles.footer} fixed>
            {t('pdf_footer')}
        </Text>
    );
};

export default PDFFooter;
